import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import SEO from './SEO';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title="Page Not Found"
        description="This page could not be found."
        noindex={true}
      />

      <Header date={new Date().toISOString()} title="Not Found" gameName="PocketHints" />

      <main className="flex-grow max-w-3xl mx-auto px-4 w-full pb-20">
        <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm text-center">
          <h1 className="text-3xl font-black text-gray-900 mb-3">404: Page not found</h1>
          <p className="text-gray-600 mb-6">
            The page you’re looking for doesn’t exist (or has been moved).
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="px-5 py-3 rounded-xl bg-brand-blue text-white font-bold hover:bg-blue-600 transition-colors"
            >
              Go Home
            </Link>
            <Link
              to="/archives"
              className="px-5 py-3 rounded-xl bg-white border border-gray-200 text-gray-900 font-bold hover:border-brand-blue/20 hover:bg-gray-50 transition-colors"
            >
              Browse Archives
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFoundPage;



